import React from 'react';
import { Grid, Button } from '@mui/material';
import { Pages, UiStore } from '@gamiphy/loyalty-station-desktop/store/ui';
import { useTranslation, Trans, useDisplayStringValue } from '@gamiphy/react-i18n';
import { ThemeStore } from '@gamiphy/loyalty-station-desktop/store/theme';
import { GameStore } from '@gamiphy/loyalty-station-desktop/store/game';
import { WelcomeGiftStore, WelcomeGiftTypes } from '@gamiphy/loyalty-station-desktop/store/welcomeGift';
import GameIcon from '../assets/GameIcon';

type Props = {
  hasIcon? : boolean,
}

const WelcomeTabGameCard: React.FC<Props> = ({ hasIcon }) => {
  const { t } = useTranslation();
  const title = useDisplayStringValue(GameStore.appGame?.title);

  return (
    <Grid container justifyContent="space-between" alignItems="center" sx={{ fontSize: '1.2rem' }} wrap="nowrap">
      {hasIcon && (
        <Grid item container justifyContent="center" alignItems="center" xs={1} sx={{ mr: 1 }}>
          <GameIcon color={ThemeStore.theme.palette?.primary?.main} />
        </Grid>
      )}
      <Grid container item sx={{ mr: 1 }}>
        <Grid item sx={{ mr: 0.5 }}>
          <Trans
            i18nKey="draft.game.description"
            defaults="Play {{game}}"
            values={{
              game: title,
            }}
          />
        </Grid>
        {WelcomeGiftStore.type === WelcomeGiftTypes.points && (
          <Grid item>
            (
            <Trans
              i18nKey="gemsValue"
              defaults="{{gems, gems}}"
              values={{
                gems: GameStore.appGame?.points.gems,
              }}
            />
            )

          </Grid>
        )}
      </Grid>
      <Grid item>
        <Button
          variant="contained"
          color="primary"
          sx={{
            fontSize: 'inherit',
            width: '8rem',
          }}
          onClick={() => {
            UiStore.setPage(Pages.game);
            UiStore.setShowGame(true);
          }}
        >
          {t('draft.game.play', {
            defaultValue: 'Play',
          })}
        </Button>
      </Grid>
    </Grid>
  );
};

export default WelcomeTabGameCard;
